import { makeAutoObservable, reaction } from "mobx";
export class OverlayStack {
    constructor() {
        this._entries = [];
        this.lastAction = null;
        makeAutoObservable(this);
    }
    get entries() {
        return this._entries;
    }
    get top() {
        var _a;
        return (_a = this._entries[this._entries.length - 1]) !== null && _a !== void 0 ? _a : null;
    }
    get isEmpty() {
        return this._entries.length === 0;
    }
    get size() {
        return this._entries.length;
    }
    push(route, ...args) {
        var _a;
        const entry = {
            route,
            params: ((_a = args[0]) !== null && _a !== void 0 ? _a : {}),
        };
        this._entries = [...this._entries, entry];
        this.lastAction = "push";
        return entry;
    }
    replace(route, ...args) {
        var _a;
        const entry = {
            route,
            params: ((_a = args[0]) !== null && _a !== void 0 ? _a : {}),
        };
        this._entries = [...this._entries.slice(0, -1), entry];
        this.lastAction = "replace";
        return entry;
    }
    pop() {
        var _a;
        if (this._entries.length === 0)
            return null;
        const popped = (_a = this._entries[this._entries.length - 1]) !== null && _a !== void 0 ? _a : null;
        this._entries = this._entries.slice(0, -1);
        this.lastAction = "pop";
        return popped;
    }
    clear() {
        this._entries = [];
        this.lastAction = "clear";
    }
    find(route) {
        return this._entries.find((e) => e.route === route);
    }
    has(route) {
        return this._entries.some((e) => e.route === route);
    }
    restore(entries) {
        this._entries = entries;
        this.lastAction = "restore";
    }
    /**
     * Subscribe to stack entry changes.
     * Fires immediately with the current state, then on every subsequent change.
     * Returns a disposer function to stop observing.
     */
    subscribe(listener) {
        return reaction(() => this._entries, listener, { fireImmediately: true });
    }
}
